import moment from "moment";
import "moment/locale/nb";
import React, { Component, Fragment } from "react";
import Navigation from "../components/molecules/Navigation/Navigation";
import "../styles/index.scss";
import getFirebase, { FirebaseContext } from "./Firebase";
import Seo from "./SEO";
import withAuthentication from "./Session/withAuthentication";

moment.locale("nb");

class Layout extends Component {
  state = {
    firebase: null,
  };

  componentDidMount() {
    const app = import("firebase/compat/app");
    const auth = import("firebase/compat/auth");
    const database = import("firebase/compat/database");

    Promise.all([app, auth, database]).then((values) => {
      const firebase = getFirebase(values[0]);

      this.setState({ firebase });
    });
  }

  render() {
    return (
      <FirebaseContext.Provider value={this.state.firebase}>
        <AppWithAuthentication {...this.props} />
      </FirebaseContext.Provider>
    );
  }
}

const AppWithAuthentication = withAuthentication(
  ({ hideNav, seo, children }) => (
    <Fragment>
      <Seo {...seo} />
      {!hideNav && <Navigation />}
      {children}
    </Fragment>
  )
);

export default Layout;
